import http from '../../../httpRequests.js';

export default {
    state(){
        return{
          
            url:'join-us',
            
           

        }
    }, 
  

    actions:{
        async joinUs(context, payload){
        const response= await http.post(context.state.url, context.rootState.lang,payload);
        
       return response;
       

        }
    }
,
   
}